import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { deskRunQuery, stopDeskRun } from '../api/easeedesk'

const ACTIVE = new Set(['queued', 'running', 'executing', 'waiting_user'])

export function TicketDeskBanner({ id }: { id: number }) {
  const client = useQueryClient()
  const { data } = useQuery(deskRunQuery(id))
  const stop = useMutation({
    mutationFn: () => stopDeskRun(id),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: deskRunQuery(id).queryKey })
    },
  })

  const run = data?.run
  if (!run) {
    return null
  }

  const canStop = ACTIVE.has(run.state) && !run.cancel_requested
  const stopping = run.cancel_requested === 1

  return (
    <div className="alert alert-info" style={{ marginBottom: 12, fontSize: 13 }}>
      <strong>AI desk:</strong>{' '}
      {run.state.replace(/_/g, ' ')}
      {run.rounds > 0 ? `, round ${run.rounds}` : ''}
      {run.trust_level != null ? `, trust ${run.trust_level}` : ''}
      {run.cost_usd > 0 ? `, ${run.cost_usd.toFixed(2)} USD` : ''}
      {run.running ? ' (running now)' : ''}
      {stopping && !canStop && <span style={{ marginLeft: 8 }}>Stop requested — the run ends at its next tool call.</span>}
      {canStop && (
        <button
          type="button"
          className="btn btn-warning btn-xs"
          style={{ marginLeft: 12 }}
          disabled={stop.isPending}
          onClick={() => {
            if (window.confirm('Stop the AI on this ticket? A colleague can continue from here.')) {
              stop.mutate()
            }
          }}
        >
          Stop the AI on this ticket
        </button>
      )}
      {stopping && canStop && <span style={{ marginLeft: 8 }}>Stop requested — the run ends at its next tool call.</span>}
    </div>
  )
}
